import { buildDeleteProofPayload, signDeleteProof, getVaultKeyring } from './crypto';

// Loeschnachweis: jede Loeschung (Papierkorb, endgueltig, ganze Ordner) traegt eine
// Unterschrift mit dem Loeschschluessel des entsperrten Tresors. Eine gestohlene Sitzung
// allein reicht dem Server damit nicht mehr, um Dateien zu entfernen.

const API_URL = '/api/tresor';

async function fetchChallenge(authenticatedFetch) {
  const res = await authenticatedFetch(`${API_URL}/delete-challenge`, { method: 'POST' });
  if (!res.ok) throw new Error('delete_challenge_failed');
  return res.json();
}

/** Nachweis fuer genau diese Aktion und diese Upload-IDs. */
export async function createDeleteProof(authenticatedFetch, masterKey, action, uploadIds) {
  if (!getVaultKeyring(masterKey)?.deleteProof) {
    const err = new Error('Dieser Browser kann den Löschnachweis nicht erzeugen (Ed25519 fehlt). Bitte einen aktuellen Browser verwenden.');
    err.code = 'DELETE_PROOF_UNAVAILABLE';
    throw err;
  }
  const { challenge, issuedAt, userId } = await fetchChallenge(authenticatedFetch);
  const payload = buildDeleteProofPayload({ userId, challenge, issuedAt, action, uploadIds });
  const signature = await signDeleteProof(masterKey, payload);
  return { challenge, issuedAt, signature };
}

/**
 * Hinterlegt den Loeschschluessel fuer Tresore, die vor dem 22.10.26 eingerichtet wurden.
 * Laeuft still beim Entsperren. Meldet 'mismatch', wenn auf dem Server ein ANDERER Schluessel
 * steht: dann hat jemand mit Zugriff auf das Konto einen eigenen eingetragen.
 */
export async function ensureDeleteProofKey(authenticatedFetch, masterKey, registeredKey) {
  const proof = getVaultKeyring(masterKey)?.deleteProof;
  if (!proof) return 'unsupported';
  if (registeredKey) return registeredKey === proof.publicKeyBase64url ? 'ok' : 'mismatch';
  const { challenge, issuedAt, userId } = await fetchChallenge(authenticatedFetch);
  const payload = ['v1', 'tresor-delete-key-register', String(userId), challenge, String(issuedAt), proof.publicKeyBase64url].join(':');
  const signature = await signDeleteProof(masterKey, payload);
  const res = await authenticatedFetch(`${API_URL}/delete-proof-key`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ publicKey: proof.publicKeyBase64url, challenge, issuedAt, signature })
  });
  if (res.status === 409) return 'mismatch';
  return res.ok ? 'registered' : 'failed';
}
